var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRecommendationStart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3005_3179)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.75 2.60012C1.75 2.40682 1.9067 2.25012 2.1 2.25012H11.9C12.0933 2.25012 12.25 2.40682 12.25 2.60012V10.6501C12.25 10.8434 12.0933 11.0001 11.9 11.0001H9.48453C9.38805 11.0001 9.29582 11.04 9.22967 11.1103L7.25486 13.2085C7.11667 13.3553 6.88333 13.3553 6.74514 13.2085L4.77031 11.1103C4.70417 11.04 4.61194 11.0001 4.51544 11.0001H2.1C1.9067 11.0001 1.75 10.8434 1.75 10.6501V2.60012Z",
    stroke: "white",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.00008 4.58345L7.83156 6.08528L9.33341 6.91678L7.83156 7.74827L7.00008 9.25012L6.1686 7.74827L4.66675 6.91678L6.1686 6.08528L7.00008 4.58345Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3005_3179"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "translate(0 0.500122)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecommendationStart);
export default __webpack_public_path__ + "static/media/recommendationStart.b045bbdb1e272377f85bfeb8058be88e.svg";
export { ForwardRef as ReactComponent };